var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16402_3735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2838 3.71585C15.1145 2.54663 13.2189 2.54664 12.0497 3.71588L11.3847 4.38089L11.3749 4.37117L10.1964 5.54968L10.2062 5.55942L3.67275 12.093C3.09974 12.6661 2.77783 13.4432 2.77783 14.2536V16.3887C2.77783 16.6097 2.86563 16.8217 3.02191 16.978C3.17819 17.1343 3.39015 17.222 3.61117 17.222L5.74623 17.222C6.55663 17.222 7.33383 16.9001 7.90686 16.3271L16.2838 7.94987C17.453 6.78067 17.4529 4.88504 16.2838 3.71585ZM11.3847 6.73793L4.85128 13.2715C4.59082 13.532 4.4445 13.8853 4.4445 14.2536L4.4445 15.5554H5.74623C6.11459 15.5554 6.46786 15.409 6.72833 15.1486L13.2617 8.61497L11.3847 6.73793ZM14.4402 7.43644L15.1053 6.77138C15.6236 6.25305 15.6236 5.41268 15.1052 4.89436C14.5869 4.37602 13.7465 4.37603 13.2282 4.89437L12.5632 5.55941L14.4402 7.43644Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16402_3735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/iconPencil.49f439683e21fa1403c072a8341d7ca9.svg";
export { ForwardRef as ReactComponent };